let language = {
    "Home":"Home",
    "CategoryList": "View Account",
    "CategoryEdit": "Add Account",
    "Language": "This Is Language File",
    "Product Name": "Account",
    "LBL_HOME":"Home",
    "LBL_USER": "Users",
    "LBL_USER_TYPE": "User Type",
    "LBL_VIEW_USER": "View Users",
    "LBL_ADD_USER": "Add Users",
    "LBL_FIRST_NAME":"First Name",
    "LBL_LAST_NAME":"Last Name",
    "LBL_USER_STATUS":"Status",
    "LBL_LOGIN_STATUS":"Login Status",
    "LBL_USER_NAME":"User Name",
    "LBL_USER_PASSWORD":"Password",
    "LBL_CONFIRM_PASSWORD":"Confirm Password",
    "LBL_DEFAULT_EMAIL":"Email Options",
    "LBL_EMAIL_CLIENT":"Email client",
    "LBL_USER_INFO":"User Information",
    "LBL_USER_DEPARTMENT":"Department",
    "LBL_USER_SEX":"Sex",
    "LBL_USER_MOBILE":"Mobile",
    "LBL_USER_QUALIFICATION":"Qualification",
    "LBL_USER_SPECIFICATION":"Specialization",
    "LBL_USER_ADDRESS_INFO":"Address Information",
    "LBL_PRIMARY_ADDRESS":"Primary Address",
    "LBL_ADDRESS_CITY":"City",
    "LBL_ADDRESS_STATE":"State",
    "LBL_ADDRESS_COUNTRY":"Country",
    "LBL_ADDRESS_POSTAL_CODE":"Postal Code",
    "LBL_USER_SETTING":"User Settings",
    "LBL_SYSTEM_ADMINISTRATOR":"System Administrator",
    "LBL_SHOW_FULLNAME":"Show Full Name",
    "LBL_LOCAL_SETTING":"Locale Settings",
    "LBL_DATE_FORMAT":"Date format",
    "LBL_TIME_FORMAT":"Time Format",
    "LBL_TIME_ZONE":"Time zone",
    "LBL_TIME_ZONEPROMPT":"Time zone prompt",
    "LBL_CURRENCY":"Currency",
    "LBL_CURRENCY_DIGIT":"Currency Significant Digits",
    "LBL_EXAMPLE":"Example",
    "LBL_SEPERATOR":"1000s separator",
    "LBL_DECIMAL_SYSBOL":"Decimal symbol",
    "LBL_DISPLAY_FORMAT":"Name Display Format",
    "LBL_BRANCH":"User Branch",
    "LBL_ROLE":"User Role",
    "LBL_CURRENT_PASSWORD":"Current password",
    "LBL_NEW_PASSWORD":"New password",
    "LBL_CONFIRM_PASSWORD":"Confirm password",
    "LBL_SAVE":"Save",
    "LBL_PERSONAL_INFO":"Personal information",
    "LBL_CHANGE_PASSWORD":"Change Password",
    "LBL_PROFILE":"Profile"
}
export default language;